<template>
    <div>
        <div class="home wrapper">
            <div class="grid-v-center">
                <h1>Finally, online<br>
                <span class="theme-color">trade shows</span>
                <br>done right.</h1>
                <LargeButton
                    @click="$smoothScroll({scrollTo: $refs.about.$el})"
                    text="Learn More"
                />
            </div>
        </div>
        <About ref="about"/>
    </div>
</template>

<script>
import About from './About'

export default {
    name: 'Home', // Don't delete this
    components: {
        About,
    }
}
</script>

<style lang="scss" scoped>
@import '../interface.scss';
.home.wrapper {
    display: grid;
    grid-template-rows: 1fr auto 1fr;
    grid-column-gap: 5px;
    justify-items: center;
    min-height: 100vh;
    .grid-v-center {
        grid-row-start: 2;
        margin: 0 auto 0 auto;
        padding: 0;
        h1 {
            font-size: 10vh;
            margin: 0;
            margin-bottom: 6vh;
        }
    }
}
.footer {
    grid-row-start: 3;
}
</style>
